export const candidatesVariables = [
  { label: "Prénom candidat", value: "candidate.firstName" },
  { label: "Nom candidat", value: "candidate.lastName" },
  { label: "Civilité candidat", value: "candidate.gender" },
];
